import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

// Libs

// Components

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

// PropTypes
export const propTypes = {
  inputRef: PropTypes.object,
  hasSelectedOption: PropTypes.bool,
  placeholder: PropTypes.string,
  handleInputChange: PropTypes.func,
  value: PropTypes.string,
  isMulti: PropTypes.bool,
  isAutosuggest: PropTypes.bool,
  isDisabled: PropTypes.bool,
}

// DefaultProps
export const defaultProps = {}

function Input(props) {
  const { inputRef, hasSelectedOption, placeholder, handleInputChange, value, isMulti, isAutosuggest, isDisabled } = props

  return (
    <input
      className={cx('control-input')}
      ref={inputRef}
      placeholder={placeholder}
      onChange={handleInputChange}
      value={value}
      data-is-multi={isMulti}
      data-is-autosuggest={isAutosuggest}
      data-is-disabled={isDisabled}
      data-is-selected={hasSelectedOption}
    />
  )
}

Input.propTypes = propTypes
Input.defaultProps = defaultProps

export default Input
